export enum MassiveLoaderMultiYearAuthorizations {
  CaricatoreMassivoMultiAnnualeEx = 'CARICATORE.MASSIVO.MULTI.ANNUALE.EXECUTE',
}

export const MassiveLoaderMultiYearExecute = [
  MassiveLoaderMultiYearAuthorizations.CaricatoreMassivoMultiAnnualeEx,
];

export const MassiveLoaderMultiYearAuthorizationsList = [...MassiveLoaderMultiYearExecute];
